import React from "react";
import PdfAnnotator from "./pdfViewer";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MainAnnotator from "./mainAnnotator";

// Add in your main app component


const App = () => {
  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} />

      <MainAnnotator />
    </div>
  );
};

export default App;
